import { Route } from "react-router-dom";
import VLEDashboard from "../../screens/vle/VLEDashboard";
import ProgramList from "../../screens/programs/ProgramList";
import ProgramDetails from "../../screens/program_manager/ProgramDetails";
import VerificationTasks from "../../screens/vle/VerificationTasks";
import VerificationTaskDetails from "../../screens/vle/VerificationTaskDetails";
import ProcurementList from "../../screens/biochar/ProcurementList";
import ProcurementScheduleInspection from "../../screens/biochar/ProcurementScheduleInspection";
import ProcurementInspection from "../../screens/biochar/ProcurementInspection";
import ProcurementDetail from "../../screens/biochar/ProcurementDetail";
import PickupOrders from "../../screens/biochar/PickupOrders";
import ManagePickupOrder from "../../screens/biochar/ManagePickupOrder";
import ProcurementPickup from "../../screens/biochar/ProcurementPickup";
import ProcurementPickupRequest from "../../screens/biochar/ProcurementPickupRequest";
import InitiateSubscriptionInvoicing from "../../screens/vle/InitiateSubscriptionInvoicing";

export const vleRoutes = [
  <Route key="vle-home" path="/" element={<VLEDashboard />} />,
  <Route key="vle-programs" path="/vle/programs" element={<ProgramList />} />,
  <Route
    key="vle-program-details"
    path="/program/:programId"
    element={<ProgramDetails />}
  />,
  <Route
    key="vle-verification-tasks"
    path="/vle/verification-tasks"
    element={<VerificationTasks />}
  />,
  <Route
    key="vle-verification-task-details"
    path="/vle/verification-task-details/:actionId"
    element={<VerificationTaskDetails />}
  />,
  <Route
    key="vle-procurement-list"
    path="/procurement-list"
    element={<ProcurementList />}
  />,
  <Route
    key="vle-procurement-schedule-inspection"
    path="/procurement/schedule-inspection/:id"
    element={<ProcurementScheduleInspection />}
  />,
  <Route
    key="vle-procurement-inspection"
    path="/procurement/inspection/:id"
    element={<ProcurementInspection />}
  />,
  <Route
    key="vle-procurement-pickup-request"
    path="/procurement/pickup-request/:id"
    element={<ProcurementPickupRequest />}
  />,
  <Route
    key="vle-procurement-detail"
    path="/procurement/:id"
    element={<ProcurementDetail />}
  />,
  <Route
    key="vle-pickup-orders"
    path="/pickup-orders"
    element={<PickupOrders />}
  />,
  <Route
    key="vle-pickup-order-detail"
    path="/pickup-order/:id"
    element={<ManagePickupOrder />}
  />,
  <Route
    key="vle-procurement-pickup"
    path="/procurement/pickup/:id"
    element={<ProcurementPickup />}
  />,
  <Route
    key="vle-initiate-subscription-invoicing"
    path="/initiate-invoice"
    element={<InitiateSubscriptionInvoicing />}
  />,
];
